



































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TestJson } from '@/testset'

export type TestHistoryData = 'A' | 'B'

type AppMode = 'runner' | 'editor' | null

@Component
export default class extends Vue {
  @Prop({ required: true }) testJson!: TestJson

  addEntry (): void {
    this.testJson.entries.push({
      label: '',
      url: '',
      volume: 1
    })
  }

  removeEntry (idx: number): void {
    this.testJson.entries.splice(idx, 1)
  }
}
